/* unplugin-vue-components disabled */import { render } from "./privacyPolicyHK.vue?vue&type=template&id=fc7150a2&scoped=true"
import script from "./privacyPolicyHK.vue?vue&type=script&lang=js"
export * from "./privacyPolicyHK.vue?vue&type=script&lang=js"

import "./privacyPolicyHK.vue?vue&type=style&index=0&id=fc7150a2&scoped=true&lang=css"

import exportComponent from "E:\\IDEAWorkSpace\\parent-net-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc7150a2"]])

export default __exports__